import { Breadcrumb, Button, Card, Col, Flex, Row, Space } from "antd";
import FormItem from "antd/es/form/FormItem";
import { FormDatePicker, FormInput, FormSelect } from "components/form/FormProvide";
import FormAntd from "components/form/FormProvide/FormAntd";
import { MainLayout } from "components/layouts";
import { useTranslation } from "react-i18next";
import { ReactComponent as DownloadIcon } from "../../../../assets/icon/downloadIcon.svg";
import TableAntd from "components/elements/Table";
import FundReportModal from "../reportModal/FundReportModal";
import dayjs from "dayjs";

const FUND_TYPE_OPTIONS = [
    { value: "PROVIDENT_FUND", label: "กองทุนสำรองเลี้ยงชีพ" },
    { value: "PRIVATE_TEACHER_FUND", label: "กองทุนสงเคราะห์ครูเอกชน" },
    { value: "EMPLOYEE_WELFARE_FUND", label: "กองทุนสงเคราะห์ลูกจ้าง" },
];

const FundReportComponent = ({
    reportFundList = [],
    fundNameOptions = [],
    isModalOpen = false,
    isExcelLoading = false,
    isPDFLoading = false,
    showReport,
    pagination,
    handleSearch = () => { },
    onChange = () => { },
    setIsModalOpen = () => { },
    showModal = () => { },
    exportFundReportExcel = () => { },
    exportFundReportPdf = () => { },
    getFundNameOptions = () => { },
}) => {
    const { t, i18n } = useTranslation();

    const columns = [
        {
            title: <div className="text-table">{t("common.index")}</div>,
            dataIndex: "index",
            key: "index",
            align: "center",
            width: 90,
            render: (_, record, idx) => (
                (pagination.pageNo - 1) * pagination.size + idx + 1
            ),
        },
        {
            title: <div className="text-table">{t("employee.label.employee_no")}</div>,
            dataIndex: "employeeNo",
            key: "employeeNo",
            align: "center",
            render: (_, record) => record?.employeeDetails?.employeeNo || "-",
        },
        {
            title: <div className="text-table">{t("name-surname")}</div>,
            dataIndex: "name",
            key: "name",
            align: "left",
            render: (_, record) => {
                const emp = record?.employeeDetails;
                if (!emp?.name) return "-";
                return i18n.language === "en"
                    ? `${emp?.nameEn} ${emp?.surNameEn}`
                    : `${emp?.name} ${emp?.surName}`;
            },
        },
        {
            title: <div className="text-table">{t("employee.label.department")}</div>,
            dataIndex: "department",
            key: "department",
            align: "left",
            render: (_, record) => {
                const dept = record?.employeeDetails?.departmentInfo;
                return dept ? (i18n.language === "en" ? dept?.organizationNameEn : dept?.organizationName) : "-";
            },
        },
        {
            title: <div className="text-table">{t("report.position")}</div>,
            dataIndex: "position",
            key: "position",
            align: "left",
            render: (_, record) => {
                const pos = record?.employeeDetails?.positionInfo;
                return pos ? (i18n.language === "en" ? pos?.positionNameEn : pos?.positionName) : "-";
            },
        },
        {
            title: <div className="text-table">{t("employee.label.employment_type")}</div>,
            dataIndex: "employmentType",
            key: "employmentType",
            align: "left",
            render: (_, record) =>
                i18n.language === "en"
                    ? (record?.employeeDetails?.employmentTypeInfo?.employmentTypeNameEn || record?.employeeDetails?.employmentTypeInfo?.employmentTypeName || "-")
                    : (record?.employeeDetails?.employmentTypeInfo?.employmentTypeName || "-"),
        },
        {
            title: <div className="text-table">{t("fund_report.label.fund_name")}</div>,
            dataIndex: "fundName",
            key: "fundName",
            align: "left",
            render: (_, record) =>
                i18n.language === "en"
                    ? (record?.fundNameEn || record?.fundName || "-")
                    : (record?.fundName || "-"),
        },
    ];

    return (
        <MainLayout>
            <FundReportModal
                isModalOpen={isModalOpen}
                setIsModalOpen={setIsModalOpen}
                isExcelLoading={isExcelLoading}
                isPDFLoading={isPDFLoading}
                exportFundReportExcel={exportFundReportExcel}
                exportFundReportPdf={exportFundReportPdf}
            />
            <Space direction="vertical" size={24} style={{ width: "100%" }}>
                <Flex vertical>
                    <Breadcrumb items={[
                        { title: t("home.header"), href: "/" },
                        { title: t("report.header"), href: "" },
                        { title: t("salary_calculation_group.header"), href: "" },
                        { title: t("fund_report.header") }
                    ]} />
                    <h2>{t("fund_report.header")}</h2>
                </Flex>

                <FormAntd onFinish={handleSearch} initialValues={{ year: dayjs() }}>
                    <FormItem shouldUpdate={(prev, curr) => prev.fundType !== curr.fundType}>
                        {({ getFieldValue, setFieldValue, resetFields }) => {
                            return (
                                <>
                                    <Card
                                        style={{
                                            backgroundColor: "white",
                                            width: "100%",
                                            marginBottom: "1vw",
                                            border: "1px solid #EAECF0",
                                        }}
                                    >
                                        <Flex vertical gap={16}>
                                            <Row gutter={24} style={{ marginLeft: "0px" }}>
                                                <Col span={8}>
                                                    <FormInput
                                                        name="employeeNo"
                                                        label={t("employee.label.employee_no")}
                                                        size="large"
                                                    />
                                                </Col>

                                                <Col span={8}>
                                                    <FormInput
                                                        name="employeeFullName"
                                                        label={t("name-surname")}
                                                        size="large"
                                                    />
                                                </Col>

                                                <Col span={8}>
                                                    <FormDatePicker
                                                        name="year"
                                                        label={t("payroll_period.label.tax_year")}
                                                        style={{ width: "100%" }}
                                                        placeholder={t("payroll_period.label.tax_year")}
                                                        size="large"
                                                        picker="year"
                                                        dateFormat="YYYY"
                                                        required
                                                    />
                                                </Col>
                                            </Row>

                                            <Row gutter={24} style={{ marginLeft: "0px" }}>
                                                <Col span={8}>
                                                    <FormDatePicker
                                                        name="month"
                                                        label={t("unit.month")}
                                                        style={{ width: "100%" }}
                                                        placeholder={t("unit.month")}
                                                        size="large"
                                                        picker="month"
                                                        dateFormat="MMMM"
                                                        required
                                                    />
                                                </Col>

                                                <Col span={8}>
                                                    <FormSelect
                                                        name="fundType"
                                                        label={t("fund_report.label.fund_type")}
                                                        options={FUND_TYPE_OPTIONS}
                                                        placeholder={t("report.please_select")}
                                                        size="large"
                                                        required
                                                        onChange={(value) => {
                                                            setFieldValue("fundName", undefined);
                                                            getFundNameOptions(value);
                                                        }}
                                                    />
                                                </Col>

                                                <Col span={8}>
                                                    <FormSelect
                                                        name="fundName"
                                                        label={t("fund_report.label.fund_name")}
                                                        options={fundNameOptions}
                                                        placeholder={t("report.please_select")}
                                                        size="large"
                                                        allowClear
                                                        mode="multiple"
                                                        disabled={!getFieldValue("fundType")}
                                                    />
                                                </Col>
                                            </Row>

                                            <Row gutter={[24, 16]} style={{ justifyContent: "end", display: "flex", gap: "16px", marginTop: "24px" }}>
                                                <Button type="default" onClick={() => { resetFields() }} style={{ borderRadius: "8px", height: "40px" }}>
                                                    {t("common.clear").toUpperCase()}
                                                </Button>
                                                <Button type="primary" htmlType="submit" style={{ borderRadius: "8px", height: "40px", backgroundColor: "var(--button-color)", boxShadow: "none" }}>
                                                    {t("creatTamplete.Search").toUpperCase()}
                                                </Button>
                                            </Row>
                                        </Flex>
                                    </Card>

                                    {showReport && (
                                        <Space direction="vertical" size={16} style={{ width: "100%" }}>
                                            <Flex justify="end">
                                                <Button type="default" style={{ height: "40px", borderRadius: "8px" }}
                                                    onClick={showModal}
                                                >
                                                    <Flex gap={8}>
                                                        <DownloadIcon />
                                                        <span style={{ color: "#59687F" }}>{t("report.downlod_doc")}</span>
                                                    </Flex>
                                                </Button>
                                            </Flex>

                                            <TableAntd
                                                rowKey="id"
                                                columns={columns}
                                                dataSource={reportFundList}
                                                onChange={onChange}
                                                pagination={pagination}
                                            />
                                        </Space>
                                    )}
                                </>
                            )
                        }}
                    </FormItem>
                </FormAntd>
            </Space>
        </MainLayout>
    )
}

export default FundReportComponent;